// src/MyComponent.js

import React, { Component } from 'react';
import { Logo } from '../Navbar/Navbar'
import './FooterStyle.css'

// const Routiing = () => {
//     return (
//         <div>
//             <h2>Hello from MyComponent!</h2>
//             <p>This is a simple functional component.</p>
//         </div>
//     );
// };

export class Footer extends Component {
    render() {
        return (
            <div className="row bg-color">
                
                <div className="col-4">

                 
                    <span className="company">Laxmanjali Softtech Pvt ltd.</span>
                </div>
                {/* <div className="col-4">
                    <strong>Links</strong>
                    <p>About Us</p>
                    <p>Services</p>
                    <p>Case Studies</p>
                    <p>How it works</p>
                    <p>Blog</p>
                    <p>Careers</p>
                    <p>Areas We Serve</p>
                </div>
                <div className="col-4">
                    <strong>3.</strong> Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu.
                </div> */}
            </div>



        )
    }
}
